// extracted by mini-css-extract-plugin
export var banner = "_np-0";
export var settingRow = "_np-2";
export var titleIcon = "_np-1";